import {ChangeDetectionStrategy, Component, contentChildren, effect, model} from '@angular/core';
import {TabDirective} from '../../directives/tabs/tab.directive';

@Component({
  selector: 'ms-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupComponent {
  activeTab = model<string>();

  readonly tabs = contentChildren(TabDirective, {descendants: true});

  constructor() {
    this.handleActiveTabChange();
  }

  handleActiveTabChange(): void {
    effect(() => {
      this.setActive(this.activeTab());
    });
  }

  private setActive(tabName: string): void {
    this.tabs().forEach(tab => {
      tab.isActive = tab.name() === tabName;
    });
  }
}
